import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Callout } from "components/ui/callout";
import * as React from "react";
import {
    CalloutAlignment,
    CalloutArrowPosition,
    useDynamicCalloutPosition,
} from "./use-dynamic-callout-position";

interface StatelessSearchbarItemProps {
    content: JSX.Element;
    children: React.ReactNode;
    align?: CalloutAlignment;
    arrowPosition?: CalloutArrowPosition;
}

export const StatelessSearchbarItemContext = React.createContext(() => {
    /* nop */
});

export const StatelessSearchbarItem: React.FC<StatelessSearchbarItemProps> = props => {
    const { content, children, align, arrowPosition } = props;
    const [dynamicRef, dynamicPosition] = useDynamicCalloutPosition();
    const [isOpen, setIsOpen] = React.useState(false);

    // Use dynamic positioning if no explicit positioning is provided
    const effectiveAlign = align || dynamicPosition.align;
    const effectiveArrowPosition = arrowPosition || dynamicPosition.arrowPosition;

    const close = React.useCallback(() => {
        setIsOpen(false);
    }, [setIsOpen]);
    const open = React.useCallback(() => {
        setIsOpen(true);
    }, [setIsOpen]);

    const renderButton = React.useCallback(() => {
        return (
            <div className="flex items-center space-x-1 cursor-pointer text-gray-700 lg:whitespace-nowrap">
                <div className="text-lg lg:truncate">{content}</div>
                <ChevronDownIcon className="w-5 h-5 text-gray-500 flex-shrink-0" />
            </div>
        );
    }, [content]);

    return (
        <div className="searchbar-item-component" ref={dynamicRef}>
            <Callout
                renderButton={renderButton}
                onOpen={open}
                forceClose={!isOpen}
                align={effectiveAlign}
                arrowPosition={effectiveArrowPosition}
                maxWidthPx={dynamicPosition.maxWidthPx}
                mobileFullWidth={dynamicPosition.mobileFullWidth}>
                <StatelessSearchbarItemContext.Provider value={close}>
                    {children}
                </StatelessSearchbarItemContext.Provider>
            </Callout>
        </div>
    );
};
